/* pl-carousel-indicator.js v1.2.0 — slideshow-* 适配 + 强化监听 */
(() => {
  const q = (root, sel) => root.querySelector(sel);
  const qa = (root, sel) => Array.prototype.slice.call(root.querySelectorAll(sel));
  const clamp = (n, a, b) => Math.min(Math.max(n, a), b);

  // 命中不同主题的 viewport/track
  function getSliderParts(root) {
    const scope = root.querySelector('.section-resource-list--carousel');
    if (!scope) return {};

    // 视口（可见区域）
    const viewport =
      scope.querySelector('slideshow-container, .slideshow__viewport, .slider__viewport') ||
      scope.querySelector('.resource-list__carousel') || // 有的主题把 viewport 直接放在这个容器上
      scope;

    // 真正移动/滚动的轨道
    const track =
      scope.querySelector('slideshow-slides, .slideshow__track, .slider__track, [data-slider-track]') ||
      (viewport && viewport.querySelector && viewport.querySelector('slideshow-slides')) ||
      (viewport && viewport.firstElementChild) ||
      scope;

    // 滑块（子项）
    const slides = qa(track, 'slideshow-slide, .slider__slide, .resource-list__item')
      .filter(el => {
        const r = el.getBoundingClientRect();
        // 排除 width=0 的隐藏项 / 克隆项（有的库会给克隆 slide 设置 aria-hidden 或透明）
        if (r.width <= 0 || r.height <= 0) return false;
        if (el.hasAttribute && (el.getAttribute('aria-hidden') === 'true' || el.dataset && (el.dataset.clone || el.dataset.cloned))) return false;
        return true;
      });
        // 可能触发 scroll 的 scroller（很多主题就是 slideshow-slides）
        const scroller = scope.querySelector('slideshow-slides') || viewport;

        return { scope, viewport, track, slides, scroller };
  }

  // 用几何法计算：以第一个 slide 的 left 为内容起点，最后一个 slide 的 right 为内容终点
  function estimateProgress(viewportEl, slides) {
    const vpEl = viewportEl || document.documentElement;
    const vp = vpEl.getBoundingClientRect();
    // 过滤宽度为 0 的隐藏/克隆项，避免把不可见 slide 算进去
    const visibleSlides = slides.filter(el => {
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
    if (!visibleSlides.length) return { pageCount: 1, page: 0, frac: 0, cols: 1 };

    const firstRect = visibleSlides[0].getBoundingClientRect();
    const lastRect  = visibleSlides[visibleSlides.length - 1].getBoundingClientRect();

    const contentStart = firstRect.left;
    const contentEnd   = lastRect.right;
    const contentWidth = Math.max(0, contentEnd - contentStart);

    // 可滚动总量 = 内容宽度 - 视口宽度
    const total = Math.max(0, contentWidth - vp.width);
    // 当前起点偏移 = 视口 left - 内容起点
    const start = Math.max(0, vp.left - contentStart);

    // 线性比例（保证末端为 1）
    const frac = total > 0 ? Math.min(1, Math.max(0, start / total)) : 0;

    // 仅用于 dots：按“视口宽度”为一页估一个页数（容忍 10% 重叠）
    const pageCount = Math.max(1, Math.round(contentWidth / (vp.width * 0.9)));
    const page = Math.round(frac * (pageCount - 1));

    // 这里的 cols 只作兼容占位，不再参与计算
    return { pageCount, page, frac, cols: 1 };
  }


  function ensureDots(ind, pageCount) {
    const dotsWrap = ind.querySelector('.pl-dots');
    if (!dotsWrap) return;
    if (dotsWrap.children.length !== pageCount) {
      dotsWrap.innerHTML = '';
      for (let i = 0; i < pageCount; i++) {
        const s = document.createElement('span');
        s.className = 'pl-dot';
        s.dataset.idx = String(i);
        dotsWrap.appendChild(s);
      }
    }
  }

  function render(ind, prog) {
    const bar = ind.querySelector('[role="progressbar"]');
    if (bar) {
      bar.setAttribute('aria-valuemax', String(prog.pageCount));
      bar.setAttribute('aria-valuenow', String(prog.page + 1));
    }
    const fill = ind.querySelector('.pl-pos-fill');
    if (fill) fill.style.width = (prog.frac * 100) + '%';
    ensureDots(ind, prog.pageCount);
    qa(ind, '.pl-dot').forEach(d => d.classList.toggle('is-active', parseInt(d.dataset.idx, 10) === prog.page));
  }

  function initSection(root) {
    const indicator = q(root, '.pl-carousel-position');
    if (!indicator) return;

    const parts = getSliderParts(root);
    if (!parts.track || !parts.slides || !parts.slides.length) return;

    const doUpdate = () => {
      const p = estimateProgress(parts.scroller || parts.viewport || parts.scope, parts.slides);
      render(indicator, p);
    };

    // 初始更新 + 延迟双触发，覆盖首屏懒加载图片导致的布局抖动
    doUpdate();
    setTimeout(doUpdate, 60);
    setTimeout(doUpdate, 240);

    // —— 监听：滚动 / 尺寸 / 属性 / 动画变更 ——
    const vp = parts.scroller || parts.viewport || window;

    // 1) scroll（若主题用真实滚动）
    if (vp && vp.addEventListener) vp.addEventListener('scroll', doUpdate, { passive: true });

    // 2) 箭头点击（你的 DOM 使用 .slideshow-control）
    qa(root, '.slideshow-control').forEach(btn =>
      btn.addEventListener('click', () => requestAnimationFrame(doUpdate), true)
    );

    // 3) ResizeObserver：视口尺寸 & 每个 slide
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => doUpdate());
      ro.observe(parts.scope);
      if (parts.viewport instanceof Element) ro.observe(parts.viewport);
      parts.slides.forEach(sl => ro.observe(sl));
    } else {
      window.addEventListener('resize', doUpdate, { passive: true });
    }

    // 4) MutationObserver：track 的 style/class/aria 变化（针对 transform 切换）
    if ('MutationObserver' in window && parts.track instanceof Element) {
      const mo = new MutationObserver(doUpdate);
      mo.observe(parts.track, { attributes: true, attributeFilter: ['style', 'class', 'aria-hidden', 'aria-current'] });
    }

    // 5) 交互时短暂开启 rAF 采样（拖拽/滚轮）
    let rafId = 0, pumping = false;
    const pump = () => { doUpdate(); rafId = requestAnimationFrame(pump); };
    const start = () => { if (!pumping) { pumping = true; rafId = requestAnimationFrame(pump); } };
    const stop  = () => { if (pumping) { pumping = false; cancelAnimationFrame(rafId); setTimeout(doUpdate, 120); } };

    (parts.track || root).addEventListener('pointerdown', start, true);
    (parts.track || root).addEventListener('touchstart', start, { passive: true });
    (parts.scroller || parts.viewport || window).addEventListener('wheel', start, { passive: true });
    window.addEventListener('pointerup', stop, true);
    window.addEventListener('touchend', stop, { passive: true });
    window.addEventListener('touchcancel', stop, { passive: true });

    // 6) 主题可能派发的事件名（覆盖更多变体）
    ['slider:change','theme:slider:change','slideshow:change','slideshow:changed',
     'slideChanged','flickity:change','swiper:slideChange','glider-animated'
    ].forEach(evt => document.addEventListener(evt, () => setTimeout(doUpdate, 0), true));
  }

  function boot() {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', e => {
    if (e && e.detail && e.detail.sectionId) {
      const root = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (root) initSection(root);
    }
  });
})();
